import { GameType } from 'names/do-names';
import { Exit } from 'slotworks/state-machine/data/exit';
import Decision from 'slotworks/state-machine/decisions/decision';
import GameInit from 'states/game-init';

export default class FreeSpinCompleteCheck extends Decision {
    public evaluate() {
        return GameInit.gameType == GameType.freeSpin ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./src/desicions/free-spin-complete-check.ts